class AppState {
}
export { AppState };
//# sourceMappingURL=AppState.js.map